import * as S from "./CmpFinishPageContent.styles";
import { Button } from "../../../atoms/Buttons";
import { ReactComponent as IconArrow } from "../../../../styles/assets/svg/icon-arrowRight.svg";
interface CmpFinishPageContentProps {
  handleConfirm: () => Promise<void>;
}

export const CmpFinishPageContent = ({
  handleConfirm,
}: CmpFinishPageContentProps) => {
  return (
    <S.ContentsSection>
      <S.TextSize>
        <S.BlueText>
          회원가입 및 <br />
          운송기사 등록 신청
        </S.BlueText>
        이<br />
        모두 완료되었습니다.
      </S.TextSize>
      <S.Textdiv>
        자격증의 심사가 진행됩니다.
        <br />
        심사는 평균 3일 정도 소요되며,
        <br />
        심사 완료 후 앱을 통해 결과를 알려드립니다.
      </S.Textdiv>
      <S.AlterBox>
        <S.AlterText>
          사업자등록증이 본인 명의가 아닌가요?
          <br />
          추가 서류를 제출해주세요.
        </S.AlterText>
        <S.AlterLink>
          제출방법 알아보기
          <IconArrow width={25} height={25} fill="#1D4ED7" />
        </S.AlterLink>
      </S.AlterBox>
      <S.ButtonContainer>
        <Button
          label="확인"
          type="button"
          color="primary"
          size="full"
          onClick={handleConfirm}
        />
      </S.ButtonContainer>
    </S.ContentsSection>
  );
};
